import { CalendlyLink, dashboardLink } from "constants/Links";

export const PlanData = {
  usage: [
    "Monthly Credits",
    "Apps",
    "Cloud Storage Volumes",
    "Custom Images",
    "GPU Concurrency",
    "CPU Concurrency",
    "API Requests",
    "Log Retention",
    "Seats",
  ],
  features: [
    "Cloud Storage Volumes",
    "Secrets Manager",
    "Deployment Logs",
    "Export Your Code",
    "Keep Warm",
    "Autoscaling",
  ],
  support: ["Community Support", "Live Chat Support", "Private Slack Channel"],
  plans: [
    {
      type: "Developer",
      price: "$0",
      usage: [
        "$30",
        "Unlimited apps",
        "Unlimited storage volumes",
        "Unlimited custom images",
        "5 Containers",
        "30 Containers",
        "Unlimited requests",
        "30 Days",
        "1 seat",
      ],
      features: [true, true, true, true, true, true, true, false],
      support: [true, true, false],
      getStartedUrl: dashboardLink,
    },
    {
      type: "Team",
      price: "$89",
      usage: [
        "$30",
        "Unlimited apps",
        "Unlimited storage volumes",
        "Unlimited custom images",
        "50 Containers",
        "1000 Containers",
        "Unlimited requests",
        "30 Days",
        "3 seats included, $25 per additional seat",
      ],
      features: [true, true, true, true, true, true, true, false],
      support: [true, true, true],
      primary: true,
      getStartedUrl: dashboardLink,
    },
    {
      type: "Growth",
      price: "Contact Us",
      usage: [
        "$30",
        "Unlimited apps",
        "Unlimited storage volumes",
        "Unlimited custom images",
        "Custom",
        "Unlimited Containers",
        "Unlimited requests",
        "1 Year",
        "Unlimited seats",
      ],
      features: [true, true, true, true, true, true, true, true],
      support: [true, true, true],
      getStartedUrl: CalendlyLink,
    },
  ],
};
